import type { BranchPermission, ModuleKey } from '../../shell/session/store/sessionTypes';
import { permissionAllowsAction } from '../../shell/session/permissions/canModuleAction';

/**
 * Anti-escalation is enforced server-side via the `enforce_ebp_anti_escalation`
 * trigger on `employee_branch_permissions` (migration 20260806044655).
 * This client-side helper only checks whether the actor can grant a specific action.
 */
export function actorCanGrantModuleAction(
  actor: BranchPermission | undefined,
  module: ModuleKey,
  action: string
): boolean {
  if (!actor || actor.module !== module) return false;
  return permissionAllowsAction(actor, action);
}
